import { parseTenantResponse } from "./tenant";

function summaryNumber(value, field, amount = false) {
  let raw = typeof value === "string" ? value.trim() : value;
  if (amount && typeof raw === "string") raw = raw.replace(/\s*Cr\.?$/i, "").trim();
  if ((typeof raw !== "number" && typeof raw !== "string") ||
      raw === "" || !/^\d+(?:\.\d+)?$/.test(String(raw))) {
    throw new Error("Loan statistics contain an invalid " + field + ".");
  }
  const number = Number(raw);
  if (!Number.isFinite(number) || number < 0 || (!amount && !Number.isSafeInteger(number))) {
    throw new Error("Loan statistics contain an invalid " + field + ".");
  }
  return number;
}

export function normalizeLoanSummary(body) {
  const response = parseTenantResponse(body);
  if (!response || Array.isArray(response) || typeof response !== "object") {
    throw new Error("The server returned an invalid loan statistics response.");
  }
  const summary = {};
  for (const field of ["totalProfile", "indApp", "groupApp", "personalLoi", "groupLoi"]) {
    summary[field] = summaryNumber(response[field], field);
  }
  const individualAmount = summaryNumber(response.personalLoiAmt, "personalLoiAmt", true);
  const groupAmount = summaryNumber(response.groupLoiAmt, "groupLoiAmt", true);
  summary.totalApp = summary.indApp + summary.groupApp;
  summary.totalLoi = summary.personalLoi + summary.groupLoi;
  if (!Number.isSafeInteger(summary.totalApp) || !Number.isSafeInteger(summary.totalLoi) ||
      !Number.isFinite(individualAmount + groupAmount)) {
    throw new Error("Loan statistics totals are outside the supported range.");
  }
  summary.totalAmt = (individualAmount + groupAmount).toFixed(3);
  summary.personalLoiAmt = individualAmount.toFixed(3) + " Cr.";
  summary.groupLoiAmt = groupAmount.toFixed(3) + " Cr.";
  return summary;
}



// WEBPACK FOOTER //
// ./src/services/loanSummary.js